<template>
  <v-container fluid>
    <notifications group="actions"></notifications>
    <h2>
      <router-link :to="'/job-offers/list'">Job Offers</router-link> &raquo; {{jobOffer.title}}
    </h2>
    <v-flex>
      <!--      <v-row>-->
      <!--        <v-col cols="12" lg="2" md="2">Title</v-col>-->
      <!--        <v-col cols="12" lg="9" md="9">{{jobOffer.title}}</v-col>-->
      <!--      </v-row>-->
      <v-row>
        <v-col>
          <router-link :to="{name: 'jobOfferSalaryReview', params: {id: getPrevious}}">
            <v-btn :disabled="!hasPrevious">Previous
            </v-btn>
          </router-link>
          <v-chip>
            {{getCurrent }} / {{getTotal}}
          </v-chip>
          <router-link :to="{name: 'jobOfferSalaryReview', params: {id: getNext}}">
            <v-btn :disabled="!hasNext">
              Next
            </v-btn>
          </router-link>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="2" md="2">Company</v-col>
        <v-col cols="12" lg="9" md="9" v-if="jobOffer.company">{{jobOffer.company.name}}</v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="2" md="2">Salary</v-col>
        <v-col cols="12" lg="9" md="9" class="py-0">
          <v-row class="py-0" v-if="jobOffer.salary">
            <v-col cols="2" class="py-0" v-for="(item, index) in jobOffer.salary" :key="index">
              <v-text-field :label="index" :value="item" disabled v-if="typeof item !== 'boolean'"></v-text-field>
              <v-switch :label="index" v-model="jobOffer.salary[index]" disabled v-else></v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="2" md="2">Proposed Salary</v-col>
        <v-col cols="12" lg="9" md="9" class="py-0">
          <v-row class="py-0">
            <v-col cols="2" class="py-0" v-for="(item, index) in proposedSalary" :key="index">
              <v-alert v-if="index === 'min' || index === 'max'" colored-border color="success lighten-3"
                       class=" pa-0 ma-0" border="bottom">
                <v-text-field :label="index" v-model="proposedSalary[index]" :value="item" v-on:keyup.enter="saveSalary"></v-text-field>
              </v-alert>
              <v-alert v-if="index === 'currency'" colored-border color="primary lighten-4"
                       class=" pa-0 ma-0" border="bottom">
                <v-select :label="index" v-model="proposedSalary[index]" :value="item" :items="currencies"></v-select>
              </v-alert>
              <v-alert v-if="index === 'frequency'" colored-border color="primary lighten-4"
                       class=" pa-0 ma-0" border="bottom">
                <v-select :label="index" v-model="proposedSalary[index]" :value="item" :items="frequencies" clearable></v-select>
              </v-alert>
              <v-alert v-if="index === 'hasBonus' || index === 'hasPerks'" colored-border color="warning lighten-1"
                       class=" pa-0 ma-0" border="bottom">
                <v-switch :label="index" v-model="proposedSalary[index]" :value="item"></v-switch>
              </v-alert>
            </v-col>
            <v-col cols="2">
              <v-btn color="success" @click="saveSalary">
                <v-icon>mdi-content-save</v-icon>
              </v-btn>
            </v-col>
          </v-row>

        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="2" md="2">SalaryRange</v-col>
        <v-col cols="12" lg="9" md="9">{{jobOffer.salaryRange}}</v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="2" md="2">Highlighted description</v-col>
        <v-col cols="12" lg="9" md="9" v-html="highlightedDescription" v-if="jobOffer.description"></v-col>
      </v-row>
      <!--      <v-row>-->
      <!--        <v-col cols="12" lg="2" md="2">Description</v-col>-->
      <!--        <v-col cols="12" lg="9" md="9">{{jobOffer.description}}</v-col>-->
      <!--      </v-row>-->
    </v-flex>
  </v-container>
</template>

<script>
  import api from '@/api/index';

  const salarySchema = {
    min: null,
    max: null,
    currency: null,
    frequency: null,
    hasBonus: false,
    hasPerks: false,
  };

  const frequencies = [
    'yearly',
    'monthly',
    'weekly',
    'daily',
    'hourly'
  ];

  const currencies = [
    'EUR',
    'USD',
    'GBP'
  ];

  export default {
    name: "SalaryReview",
    data() {
      return {
        jobOffer: {},
        proposedSalary: {},
        frequencies,
        currencies
      }
    },// define a watcher
    watch: {
      "$route.params.id"(val) {
        // call the method which loads your initial state
        this.getJobOffer();
        this.proposedSalary = salarySchema;

      },
    },
    methods: {
      getJobOffer() {
        api.jobOffers.getOne({_id: this.$route.params.id}).then(response => {
          this.jobOffer = response.data.data.jobOffer;
          if (this.jobOffer.salary === undefined) {
            this.jobOffer.salary = {};
          }
          this.proposedSalary = this.proposeSalary();
        })
      },
      saveSalary() {
        api.jobOffers.saveSalary({_id: this.$route.params.id, salary: this.proposedSalary}).then(response => {
          this.$notify({
            group: 'actions',
            type: 'success',
            text: response.data.data.message
          });
          this.jobOffer = response.data.data.jobOffer;
          setTimeout(() => this.$router.push({name: 'jobOfferSalaryReview', params: {id: this.getNextUrl()}}), 500)
        })
      },
      proposeSalary() {
        let salaryLines = '';
        if (this.jobOffer.salaryRange) {
          salaryLines = this.jobOffer.salaryRange;
        } else {
          salaryLines = this.jobOffer.description.split('\n').filter(e => e.indexOf('€') > -1).join('\n').toLowerCase();
          // must contain salar* or rate*
          if (salaryLines.indexOf('salar') === -1 && salaryLines.indexOf('rate') === -1 && salaryLines.indexOf('retribuci') === -1) {
            //return salarySchema;
          }
        }

        let range = [];
        if (salaryLines.match(/\d+\,\d+\./g)) {
          // format 23,030.00
          range = salaryLines.match(/\d+\,\d+/g).map(e => e.replace(',', ''));
        } else if (salaryLines.match(/\d+\,\d+/g)) {
          // format 25000,00€
          range = salaryLines.match(/[\d+]{3,}/g);
        } else if (/[\d+]{2} [\d+]{3}/gi.test(salaryLines)) {
          // format 25000,00€
          range = salaryLines.match(/[\d+]{2} ?[\d+]{3}/gi).map(e => e.replace(' ',''));
        } else if (salaryLines.match(/\d+K/g)) {
          // format 30K€
          range = salaryLines.match(/\d+K/g).map(e => parseInt(e.replace('K', '000')));
        } else {
          range = salaryLines.replace(/\./g, '').match(/\d+/g);
        }

        // if (range) {
        //   range = range.map(e => parseInt(e));
        // } else {
        //   return salarySchema;
        // }

        let frequency = '';
        if (/(al |\/)+año/i.test(salaryLines) || /anual/i.test(salaryLines) || /b\/a\.?/i.test(salaryLines) || /per year/i.test(salaryLines) || /\/ ?year/i.test(salaryLines) || /yearly/i.test(salaryLines)) {
          frequency = 'yearly';
        } else if (
          /al mes/i.test(salaryLines) ||
          /brutos mes/i.test(salaryLines) ||
          /mensual/i.test(salaryLines) ||
          /\/ ?mes/i.test(salaryLines) ||
          /per month/i.test(salaryLines) ||
          /\/ ?month/i.test(salaryLines) ||
          /monthly/i.test(salaryLines)) {
          frequency = 'monthly';
        } else if (/a la semana/i.test(salaryLines) || /per week/i.test(salaryLines) || /weekly/i.test(salaryLines)) {
          frequency = 'weekly';
        } else if (/al dia/i.test(salaryLines) || /al día/i.test(salaryLines) || /per day/i.test(salaryLines) || /daily/i.test(salaryLines)) {
          frequency = 'daily';
        } else if (/hora/i.test(salaryLines) || /per hour/i.test(salaryLines) || /hourly/i.test(salaryLines)) {
          frequency = 'hourly';
        }

        let hasBonus = /bonus/i.test(this.jobOffer.description) || /variable/i.test(this.jobOffer.description) || /comiss?ion/i.test(this.jobOffer.description);
        let hasPerks = /perks/i.test(this.jobOffer.description) || /beneficios/i.test(this.jobOffer.description) || /fringe benefit/i.test(this.jobOffer.description);

        //print(salaryLines.replace(/\./g,'').match(/\d+/g));
        if (range && range.length === 2 && range[1] > range[0]) {
          // could it be a range?
          return {
            min: range[0],
            max: range[1],
            currency: 'EUR',
            frequency: frequency,
            hasBonus,
            hasPerks
          };
        } else if (range && range.length === 2) {
          // could it be a bonus?
          // console.log(salaryLines, '=> base: ', range[0], ' bonus: ', range[1]);
          return {
            min: range[0],
            max: range[0],
            currency: 'EUR',
            frequency: frequency,
            hasBonus,
            hasPerks
          };
        } else if (range && range.length === 1) {
          return {
            min: range[0],
            max: range[0],
            currency: 'EUR',
            frequency: frequency,
            hasBonus,
            hasPerks
          };
        } else {
          // we should check what is it
        }

        let salary = JSON.parse(JSON.stringify(salarySchema));
        salary.currency = 'EUR';
        salary.frequency = frequency;
        salary.hasBonus = hasBonus;
        salary.hasPerks = hasPerks;
        return salary;
      },
      getNextUrl() {
        return this.$store.getters.getJobOffersList[this.$store.getters.getJobOffersList.indexOf(this.$route.params.id) + 1];
      }
    },
    mounted() {
      this.getJobOffer();
    },
    computed: {
      highlightedDescription() {
        let description = this.jobOffer.description;
        if (description.match(/\d+\,\d+\./g)) {
          // format 23,030.00
          description = description.replace(/(\d+)\,(\d+)/g, "<span class='success lighten-3'>$&</span>");
        } else if (description.match(/\d+\,\d+/g)) {
          // format 25000,00€
          description = description.replace(/[\d+]{3,}/g, "<span class='success lighten-3'>$&</span>");
        } else if (description.match(/\d+K/g)) {
          // format 30K€
          description = description.replace(/\d+K/g, "<span class='success lighten-3'>$&</span>");
        } else {
          description = description.replace(/\d+/g, "<span class='success lighten-3'>$&</span>");
        }

        // currency
        if (description.match(/€/g)) {
          // format 23,030.00
          description = description.replace(/€/g, "<span class='primary lighten-4'>$&</span>");
        }

        // frequency
        if (/(al |\/)+año/i.test(description) || /anual/i.test(description) || /b\/a\.?/i.test(description) || /per year/i.test(description) || /\/ ?year/i.test(description) || /yearly/i.test(description)) {
          description = description.replace(/(al |\/)+año/ig, "<span class='primary lighten-4'>$&</span>");
          description = description.replace(/anual/ig, "<span class='primary lighten-4'>$&</span>");
          description = description.replace(/b\/a\.?/i, "<span class='primary lighten-4'>$&</span>");
          description = description.replace(/per year/i, "<span class='primary lighten-4'>$&</span>");
          description = description.replace(/\/ ?year/i, "<span class='primary lighten-4'>$&</span>");
          description = description.replace(/yearly/i, "<span class='primary lighten-4'>$&</span>");
        } else if (
          /al mes/i.test(description) ||
          /brutos mes/i.test(description) ||
          /mensual/i.test(description) ||
          /\/ ?mes/i.test(description) ||
          /per month/i.test(description) ||
          /\/ ?month/i.test(description) ||
          /monthly/i.test(description)) {
          description = description.replace(/al mes/ig, "<span class='primary lighten-4'>$&</span>");
          description = description.replace(/brutos mes/ig, "<span class='primary lighten-4'>$&</span>");
          description = description.replace(/mensual/ig, "<span class='primary lighten-4'>$&</span>");
          description = description.replace(/\/ ?mes/i, "<span class='primary lighten-4'>$&</span>");
          description = description.replace(/per month/i, "<span class='primary lighten-4'>$&</span>");
          description = description.replace(/\/ ?month/i, "<span class='primary lighten-4'>$&</span>");
          description = description.replace(/monthly/i, "<span class='primary lighten-4'>$&</span>");
        } else if (/a la semana/i.test(description) || /per week/i.test(description) || /weekly/i.test(description)) {
          description = description.replace(/a la semana/ig, "<span class='primary lighten-4'>$&</span>");
          description = description.replace(/per week/i, "<span class='primary lighten-4'>$&</span>");
          description = description.replace(/weekly/i, "<span class='primary lighten-4'>$&</span>");
        } else if (/al dia/i.test(description) || /al día/i.test(description) || /per day/i.test(description) || /daily/i.test(description)) {
          description = description.replace(/al dia/ig, "<span class='primary lighten-4'>$&</span>");
          description = description.replace(/al día/ig, "<span class='primary lighten-4'>$&</span>");
          description = description.replace(/per day/i, "<span class='primary lighten-4'>$&</span>");
          description = description.replace(/daily/i, "<span class='primary lighten-4'>$&</span>");
        } else if (/hora/i.test(description) || /per hour/i.test(description) || /hourly/i.test(description)) {
          description = description.replace(/hora/ig, "<span class='primary lighten-4'>$&</span>");
          description = description.replace(/per hour/ig, "<span class='primary lighten-4'>$&</span>");
          description = description.replace(/hourly/i, "<span class='primary lighten-4'>$&</span>");
        }

        // bonus
        if (/bonus/i.test(description) || /variable/i.test(description) || /comiss?ion/i.test(description)) {
          description = description.replace(/bonus/ig, "<span class='warning lighten-1'>$&</span>");
          description = description.replace(/variable/ig, "<span class='warning lighten-1'>$&</span>");
          description = description.replace(/comiss?ion/ig, "<span class='warning lighten-1'>$&</span>");
        }
        // perks
        if (/perks/i.test(description) || /beneficios/i.test(description) || /fringe benefit/i.test(description)) {
          description = description.replace(/perks/ig, "<span class='warning lighten-1'>$&</span>");
          description = description.replace(/beneficios/ig, "<span class='warning lighten-1'>$&</span>");
          description = description.replace(/fringe benefit/ig, "<span class='warning lighten-1'>$&</span>");
        }


        return description;
      },
      hasPrevious() {
        return this.$store.getters.getJobOffersList.indexOf(this.$route.params.id) > 0;
      },
      hasNext() {
        return this.$store.getters.getJobOffersList.indexOf(this.$route.params.id) !== this.$store.getters.getJobOffersList.length - 1;
      },
      getCurrent() {
        return this.$store.getters.getJobOffersList.indexOf(this.$route.params.id);
      },
      getTotal() {
        return this.$store.getters.getJobOffersList.length;
      },
      getPrevious() {
        return this.$store.getters.getJobOffersList[this.$store.getters.getJobOffersList.indexOf(this.$route.params.id) - 1];
      },
      getNext() {
        return this.$store.getters.getJobOffersList[this.$store.getters.getJobOffersList.indexOf(this.$route.params.id) + 1];
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/job-offers/SalaryReview.vue